export { default } from "./row.component"
